import { render, staticRenderFns } from "./RegisterUmkm.vue?vue&type=template&id=2cdce3f0&"
import script from "./RegisterUmkm.vue?vue&type=script&lang=js&"
export * from "./RegisterUmkm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports